export class AudienceDetailsRequest {
    constructor() {
        this.Name = '';
        this.Description = '';
        this.DynamicCriteriaJson = '';
        this.Tags = '';
        this.PropertyCodes = '';
        this.IsActive = false;
        this.AudienceID = 0;
        this.AudienceDetailsID = 0;
        this.Publish = false;
    }
}
//# sourceMappingURL=AudienceDetailsRequest.js.map